import { listMenu } from "@/api/system/menu";
import { listSettingComponentType } from "@/api/setting/settingComponentType";
import { listAllEntity } from "@/api/kl/entity";
/**
 * presetFunction_
 */
export default {
    /** 菜单 presetFunction_menuList */
    menuList: {
        queryFunction: listMenu,
        fieldNames: { value: 'cpid', label: 'companyName' }
    },
    /** 菜单 presetFunction_settingComponentType */
    settingComponentType: {
        queryFunction: listSettingComponentType,
        extendQueryWhere: {},
        fieldNames: { value: 'componentTypeId', label: 'componentTypeName', children: 'children', parentId: 'parentTypeId', treeCode: 'componentTypeCode' }
    },
    /** 菜单 presetFunction_entityList */
    entityList: {
        queryFunction: listAllEntity,
        extendQueryWhere: {},
        fieldNames: { value: 'id', label: 'entityName', children: 'children', parentId: 'parentId' }
    },
}